import * as Yup from "yup";

// Strict email regex - only allows alphanumeric, dots, underscores, plus, and hyphens
const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const emailValidation = Yup.string()
    .required("This field is required!")
    .matches(emailRegex, "Please enter a valid email address");

export const loginSchema = Yup.object().shape({
    email: emailValidation,
    password: Yup.string().required("This field is required!"),
});

export const agentloginSchema = Yup.object().shape({
    username: emailValidation,
    password: Yup.string().required("This field is required!"),
});

export const loginDemoSchema = Yup.object().shape({
    email: emailValidation,
    password: Yup.string().required("This field is required!"),
});

export const forgotPassSchema = Yup.object().shape({
    email: emailValidation,
});

export const signupEmailSchema = Yup.object().shape({
    email: emailValidation,
});

export const signupNameSchema = Yup.object().shape({
    first_name: Yup.string().trim().required("This field is required!"),
    last_name: Yup.string().trim().required("This field is required!"),
});

export const forgotPassEmailSchema = Yup.object().shape({
    email: emailValidation,
});

export const signupPasswordSchema = Yup.object().shape({
    password: Yup.string().required("This field is required!"),
    ReEnterPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("This field is required!"),
});

export const resetPassSchema = Yup.object().shape({
    password: Yup.string().required("This field is required!"),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("This field is required!"),
});

// Name validation: only letters (including accented), spaces, hyphens, and apostrophes
const nameValidationPattern = /^[a-zA-ZÀ-ÖØ-öø-ÿĀ-žА-яЁё\s'-]+$/;
const nameValidationMessage = "Numbers are not allowed";

export const createNewCartCustomerSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    firstName: Yup.string()
        .required("First name is required!")
        .matches(nameValidationPattern, nameValidationMessage),
    lastName: Yup.string()
        .required("Last name is required!")
        .matches(nameValidationPattern, nameValidationMessage),
    phoneNumber: Yup.string().required("Phone number is required!"),
    email: Yup.string()
        .required("Email is required!")
        .matches(emailRegex, "Please enter a valid email address"),
    postalCode: Yup.string().required("Postal code is required!"),
    countryCode: Yup.string().required("Country is required!"),
    dateOfBirth: Yup.string().required("Date of birth is required!"),
    customerIndex: Yup.number().required("Customer index is required!"),
});
